<template>
  <date-range-picker
    ref="picker"
    opens="right"
    :locale-data="{
      direction: 'ltr',
      format: 'mm/dd/yyyy',
      separator: ' - ',
      applyLabel: 'Apply',
      cancelLabel: 'Cancel',
      weekLabel: 's',
      customRangeLabel: 'Custom Range',
      daysOfWeek: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sext', 'Sab'],
      monthNames: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Aug', 'Set', 'Oct', 'Nov', 'Dec'],
      firstDay: 0
    }"
    :minDate="minDate"
    :singleDatePicker="singleDatePicker"
    :timePicker="timePicker"
    :timePicker24Hour="timePicker24Hour"
    :showWeekNumbers="showWeekNumbers"
    :showDropdowns="showDropdowns"
    :autoApply="autoApply"
    v-model="dateRange"
    :appendToBody="true"
    :linkedCalendars="linkedCalendars"
    :ranges="false"
  >
  <template v-slot:input="picker" style="min-width: 350px;">
    <v-layout align-center>
      <v-flex shrink >
        <Icon class="mt-1" size="18px" name="calendare" />
      </v-flex>
      <v-chip class="ma-1" color="primary" dark v-if="dateSelected" v-model="chipDate" close small>
        {{ displayStartDate }} - {{ displayEndDate }}
      </v-chip>
      <div class="pa-1" v-else>
        <span  class="ml-1 text-holder hidden-sm-and-up" v-if="!picker.startDate">Datas</span>
        <span class="ml-1 text-holder hidden-sm-and-down" v-if="!picker.startDate">Periodo de tempo</span>
        {{ picker.startDate | date }}  {{ picker.endDate | date }}
      </div>
    </v-layout>
  </template>
  </date-range-picker>
</template>

<script>
  import moment from 'moment'
  import DateRangePicker from 'vue2-daterange-picker'
  //you need to import the CSS manually
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

  export default {
      components: { DateRangePicker },
      props: {
        endDate: { default: null },
        startDate: { default: null },
        singleDatePicker: { default: false }
      },
      filters: {
        date (value) {
          if (!value) { return '' }
          return moment(value).format('DD/MM/YYYY')
        }
      },
      data () {
        return {
          opens: 'left',
          minDate: '2019-05-02 04:00:00',
          dateRange: {
            startDate: '',
            endDate: '',
          },
          single_range_picker: false,
          show_ranges: true,
          timePicker: false,
          timePicker24Hour: false,
          showDropdowns: false,
          autoApply: true,
          showWeekNumbers: false,
          linkedCalendars: false,
          alwaysShowCalendars: false,
          appendToBody: false,
          closeOnEsc: true,
          displayStartDate: null,
          displayEndDate: null,
          chipDate: true
        }
      },
    computed: {
      dateSelected() {
        if(this.displayStartDate === null || this.displayStartDate === 'Invalid date') {
          return false
        }
        return true
      }
    },
    watch: {
      startDate (val) {
        if(val) {
          this.dateRange.startDate = val
        }
      },
      endDate (val) {
        if(val) {
          this.dateRange.endDate = val
        }
      },
      dateRange: {
        handler(newVal) {
          this.$emit('update:startDate', newVal.startDate)
          this.$emit('update:endDate', newVal.endDate)
          this.chipDate = true
          this.displayStartDate = moment(newVal.startDate).format('DD/MM/YYYY')
          this.displayEndDate = moment(newVal.endDate).format('DD/MM/YYYY')
        },
        deep: true
      },
      chipDate (val) {
        if (val === false) {
          this.dateRange = {
            startDate: null,
            endDate: null,
          }
          this.displayStartDate = ''
          this.displayEndDate= ''
        }
      }
    }
  }
</script>

<style>
.vue-daterange-picker {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0;
}
.reportrange-text {
  padding: 0 10px !important;
  border: 1px solid #e0e0e0 !important;
  min-height: 48px;
  border-radius: 10px;
  background-color: #fff !important;
  color: rgb(114 114 114);
  font-size: 16px;
  display: flex;
}
.reportrange-text .text-holder {
  position: relative;
}
</style>